import { motion } from "framer-motion";

const CHAPTERS = [
  {
    no: "01",
    title: "We start with the P&L, not the pitch.",
    text: "The first meeting isn't a case-study slideshow. We reverse-engineer the number you need to hit next quarter, then work backwards to the ads, sites and creative that get you there. Boring on purpose.",
    image: "https://images.pexels.com/photos/669615/pexels-photo-669615.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "P&L-first thinking",
  },
  {
    no: "02",
    title: "Five years in — still shipping quietly.",
    text: "Since 2020 we've built for 200+ brands across India, UK, US and the UAE. No burn books, no manufactured playbooks. Just tested plays, senior operators who stay, and a bias for shipping over talking.",
    image: "https://images.pexels.com/photos/2827400/pexels-photo-2827400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Mumbai · Est. 2020",
  },
  {
    no: "03",
    title: "The moat is craft, not headcount.",
    text: "You could hire ten juniors or four senior people who treat your brand like their own. We picked craft. It scales — just not linearly. That's the trade you make when you decide the work matters.",
    image: "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Craft over headcount",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto"
      className="relative border-t border-white/10 bg-[#0a0a0a] py-28 md:py-40"
    >
      <div className="mx-auto max-w-[90rem] px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/65">
          / How Adinvo actually works
        </p>

        <div className="mt-14 space-y-2 divide-y divide-white/10">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.no}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`chapter-${c.no}`}
              className="grid gap-8 py-14 md:grid-cols-12 md:items-center"
            >
              <span className="font-display text-6xl font-extrabold tracking-tighter text-white/35 md:col-span-1 md:text-7xl">
                {c.no}
              </span>
              <div className="md:col-span-5">
                <h3 className="font-display text-3xl font-bold leading-tight tracking-tight text-white md:text-5xl">
                  {c.title}
                </h3>
                <p className="mt-5 text-white/75 leading-relaxed">{c.text}</p>
              </div>
              <div className="md:col-span-6">
                <div className={`relative overflow-hidden rounded-2xl border border-white/10 ${i % 2 === 1 ? "md:ml-auto" : ""}`}>
                  <div className="relative aspect-[16/10] w-full">
                    <img
                      src={c.image}
                      alt={c.caption}
                      loading="lazy"
                      className="h-full w-full object-cover grayscale contrast-125 opacity-85"
                    />
                    <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/20 to-black/40" />
                    <span className="absolute bottom-5 left-5 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-white">
                      / {c.caption}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
